import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Inactive: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M1.77777778,0 C0.791111111,0 0,0.791111111 0,1.77777778 L0,14.2222222 C0,15.2040618 0.795938223,16 1.77777778,16 L14.2222222,16 C15.2040618,16 16,15.2040618 16,14.2222222 L16,1.77777778 C16,0.791111111 15.2,0 14.2222222,0 L1.77777778,0 Z M14.2222222,1.77777778 L14.2222222,14.2222222 L1.77777778,14.2222222 L1.77777778,1.77777778 L14.2222222,1.77777778 Z"
        />
    </SvgIcon>
);

export default Inactive;
